var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"col-sm-12 remove-pad\">\n<div class=\"navbar-header\">\n<h4 class=\"navbar-brand\" style=\"margin: 0px;\">\n{{'delivery_region_routing.edit_delivery_region_routing' | translate}}\n<span ng-if=\"$ctrl.loading\" class=\"glyphicon glyphicon-refresh fast-right-spinner\"></span>\n</h4>\n</div>\n</div>";
var id1="delivery_region_routing.edit.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/delivery_region_routing/edit/delivery_region_routing.edit.html
// module id = 2722
// module chunks = 1